class PriceDelegate {
    setRows(rows) {
        this.setState((prevState) => {
            return { rows };
        });
    }
}
export default PriceDelegate;
